const SET_TOP_BAR_HEIGHT = 'setTopBarHeight';

export default {
  SET_TOP_BAR_HEIGHT,
};
